import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  set (name: any, value: any) {
    localStorage.setItem(name, value);
  }

  get (name: any): any {
    try {
      return localStorage.getItem(name);
    } catch (error) {
      console.error('storage failure: ', error);
      return null;
    }
  }

  remove (name: any) {
    localStorage.removeItem(name);
  }

  clear () {
    localStorage.clear();
  }

}
